import { computed, Injectable } from '@angular/core';
import {
  CompanyModel,
  CurrentContextService,
  FlipperFlags,
} from '@callrail/looky/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AgencyModel } from '@callrail/looky/core';

@Injectable({
  providedIn: 'root',
})
export class SignalContextService {
  public agency = toSignal(this.og.agency, { requireSync: true });
  public company = toSignal(this.og.company, { requireSync: true });
  public user = toSignal(this.og.user, { requireSync: true });
  public agencyId = computed(() => this.agency()?.id);
  public companyId = computed(() => this.company()?.id);
  public userId = computed(() => this.user()?.id);
  public callrailAware = computed(() => this.user()?.support_links);
  public flippers = computed(() => this.og.eagerFlippers as FlipperFlags[]);
  public isVaFirstPlan = computed(() => !!this.agency()?.va_without_calls);

  constructor(private og: CurrentContextService) {}

  public get env() {
    return this.og.env;
  }

  public get userCompanies(): CompanyModel[] {
    return this.og.current_user_companies;
  }

  public setPageTitle(title: string) {
    this.og.setPageTitle(title);
  }

  public reloadAgency(): Observable<AgencyModel> {
    return this.og.reloadAgency();
  }

  public reloadCompany(): void {
    this.og.reloadCompany();
  }
}
